import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {reaction} from 'mobx'
import {EditorState, Modifier} from 'draft-js'
import {Tag} from 'antd'
import uniqid from 'uniqid'

import Parser from './functions/parser'

import style from './suggestions.sass'

@inject('store') @observer
class Suggestions extends Component {
  state = {suggestions:[],text:'',id:uniqid()}
  componentDidMount() {
    this.createSuggestions()
    const {algo, symbols} = this.props.store
    this.disposers = [
      reaction(
        () => algo.single.data.has_coin,
        () => this.createSuggestions()
      ),
      reaction(
        () => symbols.symbols.length,
        () => this.createSuggestions()
      ),
      reaction(
        () => algo.single[this.props.name].text,
        () => this.createSuggestions()
      )
    ]
  }
  componentWillUnmount() {
    this.disposers.forEach(dispose => dispose())
  }
  createSuggestions = () => {
    const text = this.props.store.algo.single[this.props.name].text || ''
    const {symbols} = this.props.store.symbols
    const findSymbol = text => {
      return symbols.includes(text.toUpperCase())
    }
    const {has_coin} = this.props.store.algo.single.data
    const suggestions = new Parser(findSymbol, has_coin).createSuggestions(text)
    this.setState({suggestions})
  }
  insert = (e) => {
    const {editorState} = this.props
    const value = e.target?.getAttribute('value')
    const content = editorState.getCurrentContent()
    const lastBlock = content.getLastBlock()
    const blockKey = lastBlock.getKey()
    const blockLength = lastBlock.getLength()
    const selection = editorState.getSelection()
    const targetRange = selection.merge({
      anchorKey: blockKey,
      focusKey: blockKey,
      anchorOffset: blockLength,
      focusOffset: blockLength
    })
    const updatedContent = Modifier.insertText(
      content,
      targetRange,
      value
    )

    const updatedEditorState = EditorState.push(
      editorState,
      updatedContent,
      'insert-text'
    )

    const updatedSelection = targetRange.merge({
      anchorOffset: blockLength + value.length,
      focusOffset: blockLength + value.length
    })

    const restoreSelection = EditorState.forceSelection(
      updatedEditorState,
      updatedSelection
    )

    this.props.handleChange(restoreSelection)
    this.props.onFocus()
  }
  render() {
    const {suggestions} = this.state
    const {permissions} = this.props.store
    return(
      <div>
        {suggestions.map(s => (
          s.values.map((suggestion, index) => (
            <Tag
              key={`${s.kind}-${index}`}
              value={s.open_modal ? s.symbol : suggestion}
              onClick={s.kind === 'sentiment_alternative_tag' ? (e) => permissions.wrap('lab.alternative.use', () => this.insert(e), true) : this.insert}
              styleName='tag'
            >
              {suggestion}
            </Tag>
          ))
        ))}
      </div>
    )
  }
}

export default Suggestions
